import { translationService } from "../translation/TranslationService";
import Language from "../translation/language";

// Every money amount the API sends (prices, balance, activity charges, price tiers) is in
// euro-cents. Whole euros drop the decimals ("15 €"), anything else shows two ("2,40 €").
export const formatEuro = (cents: number) => {
    const euros = (cents ?? 0) / 100;
    const locale = translationService.language === Language.german ? "de-DE" : "en-GB";
    const fractionDigits = Number.isInteger(euros) ? 0 : 2;
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: 2,
    }).format(euros);
};
